import { Helmet } from 'react-helmet-async';
// sections
import { JwtLoginView } from 'src/sections/auth/jwt';

// ----------------------------------------------------------------------

export default function LoginPage() {
  return (
    <>
      <Helmet>
        <title>{window.REACT_APP_TITLE}</title>
      </Helmet>

      {/* login view  */}
      <JwtLoginView />
    </>
  );
}
